<template>
  <v-container>
    <v-layout row>
      <v-subheader v-t="'icon'"></v-subheader>
    </v-layout>
    <v-layout row>
      <v-layout wrap justify-space-around align-center>
        <v-avatar
          v-for="(chara, name) in characters"
          :key="name"
          :color="character === name ? 'primary' : ''"
        >
          <v-icon v-if="name === 'none'" @click="character = 'none'" class="character_icon">block</v-icon>
          <img v-else :src="chara.icon" @click="character = name" class="character_icon" />
        </v-avatar>
      </v-layout>
    </v-layout>
    <v-layout row>
      <v-layout>
        <div class="character-name">
          <p v-t="this.characters[this.character].namePath"></p>
        </div>
      </v-layout>
    </v-layout>
  </v-container>
</template>

<style scoped>
img.character_icon {
  width: 40px;
  height: 40px;
}

div.character-name {
  width: 100%;
  text-align: center;
}
</style>

<script>
const vipsCoinIcon = require('../assets/coin.png')
const kanameIcon = require('../assets/kaname.png')
const irohaIcon = require('../assets/iroha.png')
const risaIcon = require('../assets/risa.png')
const hikariIcon = require('../assets/hikari.png')
const moyashiIcon = require('../assets/moyashi.png')
const terekoIcon = require('../assets/tereko.png')
const bbaNormalIcon = require('../assets/bba_normal.png')
const bbaSecondIcon = require('../assets/bba_second.png')
const hoodieIcon = require('../assets/hoodie.png')
const vipsChanIcon = require('../assets/vips_chan.png')
const pinkIcon = require('../assets/pink.png')
const cosplayIcon = require('../assets/cosplay.png')

export default {
  data () {
    return {
      character: 'coin',
      characters: {
        none: {
          namePath: 'characters.none',
          icon: null
        },
        coin: {
          namePath: 'characters.coin',
          icon: vipsCoinIcon
        },
        kaname: {
          namePath: 'characters.kaname',
          icon: kanameIcon
        },
        iroha: {
          namePath: 'characters.iroha',
          icon: irohaIcon
        },
        risa: {
          namePath: 'characters.risa',
          icon: risaIcon
        },
        hikari: {
          namePath: 'characters.hikari',
          icon: hikariIcon
        },
        moyashi: {
          namePath: 'characters.moyashi',
          icon: moyashiIcon
        },
        tereko: {
          namePath: 'characters.tereko',
          icon: terekoIcon
        },
        bba_normal: {
          namePath: 'characters.bba_normal',
          icon: bbaNormalIcon
        },
        bba_second: {
          namePath: 'characters.bba_second',
          icon: bbaSecondIcon
        },
        hoodie: {
          namePath: 'characters.hoodie',
          icon: hoodieIcon
        },
        vips_chan: {
          namePath: 'characters.vips_chan',
          icon: vipsChanIcon
        },
        pink: {
          namePath: 'characters.pink',
          icon: pinkIcon
        },
        cosplay: {
          namePath: 'characters.cosplay',
          icon: cosplayIcon
        }
      }
    }
  },
  mounted: function () {
    this.$store.commit('changeCharacter', this.characters[this.character])
  },
  watch: {
    character: function () {
      this.$store.commit('changeCharacter', this.characters[this.character])
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/CharacterSelector.vue